import { WhatsAppMessageType } from "../..";
import EventBus from "../event-bus";

const receiveMessageHook = new EventBus<WhatsAppMessageType>(
  "receiveMessageHook"
);

export default receiveMessageHook;
